

export function get_tree_from_schema(schema){
    if (schema && schema.type == 'object'){
        let res = {}
        for (let key in schema.properties){
            res[key] = get_tree_from_schema(schema.properties[key])
        }
        return res
    }
    else if (schema && schema.type == 'array'){
        return [get_tree_from_schema(schema.items)]
    }
    else {
        return null
    }
}

function get_default_for_type(type){
    if (type === 'object'){
        return {}
    }
    else if (type === 'array'){
        return []
    }
    else if (type === 'string'){
        return null
    }
    else if (type === 'number' || type === 'integer'){
        return null
    }
    else if (type === 'boolean'){
        return null
    }
    else{
        return null
    }
}

export function fill_instance_from_schema(instance,schema){
    if (schema.type === 'object' && schema.properties){
        for (let key in schema.properties){
            let subtype = schema.properties[key]['type']
            let need_object = (subtype === 'object' && (typeof instance[key] !== 'object' || instance[key] === null))
            if (instance[key] === undefined || need_object){
                instance[key] = get_default_for_type(subtype)
            }
            instance[key] = fill_instance_from_schema(instance[key],schema.properties[key])
        }
    }
    else if (schema.type === 'array' && schema.items){
        if (!Array.isArray(instance)){
            instance = []
        }
        instance = instance.map( (item) => fill_instance_from_schema(item,schema.items) )
        return instance
    }
    else if (schema.type === 'string'){
        return instance
    }
    else if (schema.type === 'number' || schema.type === 'integer'){
        return instance
    }
    else if (schema.type === 'boolean'){
        return instance
    }
    else{
        return instance
    }
    return instance

}